// Shared rooms use the configured Cocos host; links carry only a room and referral context.
export const HOLDEM_GAME_ID = "241";
const HOLDEM_AGENT_RID = /^[1-9][0-9]{0,19}$/;

export function readHoldemRoomInvite(search) {
  const query = new URLSearchParams(search);
  const rooms = query.getAll("holdem_room_id");
  const subids = query.getAll("holdem_subid");
  if (rooms.length !== 1 || subids.length !== 1) return null;
  const roomId = rooms[0];
  const subid = subids[0];
  if (!/^[A-Za-z0-9_:-]{1,128}$/.test(roomId) || !/^(0|[1-9][0-9]*)$/.test(subid) ||
    !Number.isSafeInteger(Number(subid))) return null;
  return { roomId, subid };
}

export function isHoldemRegisteredPlayer(userInfo) {
  return Boolean(userInfo && userInfo.token && !userInfo.is_guest && !userInfo.is_demo);
}

export function holdemInviteHomePath(search) {
  const invite = readHoldemRoomInvite(search);
  if (!invite) return null;
  const incoming = new URLSearchParams(search);
  const query = new URLSearchParams({ holdem_room_id: invite.roomId, holdem_subid: invite.subid });
  const agentRids = incoming.getAll("aid");
  if (agentRids.length === 1 && HOLDEM_AGENT_RID.test(agentRids[0])) query.set("aid", agentRids[0]);
  ["f", "c", "p"].forEach((key) => {
    const value = incoming.get(key);
    if (value && value !== "undefined" && value.length <= 128) query.set(key, value);
  });
  return `/home?${query.toString()}`;
}

export function holdemGameUrlWithHall(gameUrl, gameId, hallOrigin) {
  if (String(gameId) !== HOLDEM_GAME_ID) return gameUrl;
  const url = new URL(gameUrl, hallOrigin);
  url.searchParams.set("game_id", HOLDEM_GAME_ID);
  url.searchParams.set("holdem_hall_url", new URL("/home", hallOrigin).href);
  return url.href;
}

export function holdemGameUrlWithRoom(gameUrl, gameId, hallOrigin, outerSearch) {
  if (String(gameId) !== HOLDEM_GAME_ID) return gameUrl;
  const url = new URL(holdemGameUrlWithHall(gameUrl, gameId, hallOrigin));
  const query = new URLSearchParams(outerSearch);
  if (query.has("holdem_room_id") || query.has("holdem_subid")) {
    url.searchParams.delete("holdem_room_id");
    url.searchParams.delete("holdem_subid");
    const invite = readHoldemRoomInvite(query);
    if (invite) {
      url.searchParams.set("holdem_room_id", invite.roomId);
      url.searchParams.set("holdem_subid", invite.subid);
    }
  }
  return url.href;
}

export function holdemRoomGamePath(search, gameBaseUrl, hallOrigin) {
  const invite = readHoldemRoomInvite(search);
  if (!invite) return null;
  const url = new URL(holdemGameUrlWithHall(gameBaseUrl, HOLDEM_GAME_ID, hallOrigin));
  url.searchParams.set("holdem_room_id", invite.roomId);
  url.searchParams.set("holdem_subid", invite.subid);
  const query = new URLSearchParams({ game_id: HOLDEM_GAME_ID, url: url.href,
    holdem_room_id: invite.roomId, holdem_subid: invite.subid });
  const homeQuery = new URLSearchParams(holdemInviteHomePath(search).split("?")[1]);
  ["aid", "f", "c", "p"].forEach((key) => {
    const value = homeQuery.get(key);
    if (value) query.set(key, value);
  });
  return `/game?${query.toString()}`;
}

export function holdemRegistrationPath(homePath) {
  const query = new URLSearchParams({ reg: "1", back_to: homePath });
  const channel = new URLSearchParams(homePath.split("?")[1]).get("c");
  if (channel) query.set("c", channel);
  return `/login?${query.toString()}`;
}

export function holdemAuthReturnPath(backTo) {
  if (typeof backTo !== "string" || !backTo.startsWith("/home?")) return null;
  return holdemInviteHomePath(backTo.slice("/home".length));
}

// Registration must use this invite's commission parent, never stale local attribution.
export function holdemRegistrationAgentRid(backTo, storedAgentRid) {
  const homePath = holdemAuthReturnPath(backTo);
  if (!homePath) return storedAgentRid || "";
  return new URLSearchParams(homePath.split("?")[1]).get("aid") || "";
}
